import styled from 'styled-components';
import { Link } from '../Link/Link.web.js';
import { styles } from '../constants/styles.js';

var forwardLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "styles__forwardLink",
  componentId: "sc-ym5acd-0"
})(["display:", ";align-items:center;", "{svg{stroke-dashoffset:0;}}"], function (props) {
  return props.display || 'inline-flex';
}, styles.breakpointMax.m);

export { forwardLink };
